import "react-vertical-timeline-component/style.min.css";
import { Card, Empty, Button, Modal, Form, Input } from "antd";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import { timeAgo } from "~/utils/app";
import { useEffect, useState } from "react";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { reject, applications } from "~/redux/actions/talent";
import { showAppMessage } from "~/redux/actions/app";

const { confirm } = Modal;
const { TextArea } = Input;
const statusArray = [
  "contacting",
  "interviewing",
  "accepted",
  "offering",
  "offered",
];

const StatusCard = (props) => {
  const [currentStatus, setCurrentStatus] = useState();
  const [visible, setVisible] = useState(false);
  const [reason, setReason] = useState();

  useEffect(() => {
    props.statusHistoryData && setCurrentStatus(props.statusHistoryData[0]);
  }, [props.statusHistoryData]);

  const showConfirm = (candidate_id) => {
    confirm({
      title: "确定撤回申请吗？",
      icon: <ExclamationCircleOutlined />,
      content: "",
      onOk() {
        props.reject({
          token: props.token,
          candidate_id,
          cb: () => {
            props.applications({ token: props.token });
          },
        });
      },
      onCancel() {},
    });
  };

  return (
    <Card title="申请进度" className="status-wrapper" styl={{ padding: "0" }}>
      <Modal
        title="确认放弃申请该职位？"
        visible={visible}
        onOk={() => {
          if (!reason) {
            props.showAppMessage("请输入放弃申请的原因", "error");
            return;
          }
          props.reject({
            token: props.token,
            candidate_id: props.candidateId,
            reason,
            cb: () => {
              props.applications({ token: props.token });
            },
          });
          setVisible(false);
        }}
        onCancel={() => setVisible(false)}
        okText="确认"
        cancelText="取消"
      >
        <Form>
          <Form.Item>
            <TextArea
              placeholder="请输入放弃申请的原因"
              onChange={(e) => {
                setReason(e.target.value);
              }}
            />
          </Form.Item>
        </Form>
      </Modal>
      {props.statusHistoryData && props.statusHistoryData.length > 0 ? (
        <>
          <VerticalTimeline
            layout="1-column-left"
            lineColor="#f6f6f6"
            animate={false}
          >
            {props.statusHistoryData.map((s) => (
              <VerticalTimelineElement
                key={s.id}
                className="vertical-timeline-element--work"
                contentStyle={
                  currentStatus && currentStatus.id === s.id
                    ? { background: "#f9ba48", color: "white" }
                    : { background: "#f6f6f6", color: "#333" }
                }
                contentArrowStyle={{ borderRight: "7px solid  #f6f6f6" }}
                date={timeAgo(s.created_at)}
                dateClassName="time-line-date"
                iconClassName={
                  currentStatus && currentStatus.id === s.id
                    ? "current-time-item"
                    : "time-item"
                }
              >
                <div className="title">{s.title}</div>
                <div className="content">{s.content}</div>
              </VerticalTimelineElement>
            ))}
          </VerticalTimeline>
          {props.statusHistoryData.length > 1 &&
            statusArray.includes(props.statusHistoryData[0].to) && (
              <Button
                type="primary"
                style={{ backgroundColor: "red" }}
                className="mt-30"
                block
                onClick={() => {
                  setVisible(true);
                }}
              >
                放弃申请
              </Button>
            )}
          {props.statusHistoryData.length === 1 &&
            props.statusHistoryData[0].to === "new" && (
              <Button
                type="primary"
                style={{ backgroundColor: "red" }}
                className="mt-30"
                block
                onClick={() => showConfirm(props.candidateId)}
              >
                撤回申请
              </Button>
            )}
        </>
      ) : (
        <Empty></Empty>
      )}
    </Card>
  );
};

const mapStateToProps = (state) => ({
  token: state.user.token,
  statusHistoryData: state.talent.statusHistoryData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ reject, applications, showAppMessage }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(StatusCard);
